/**
 * @generated SignedSource<<d45626e8822b014472a7de42cce5c25c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductImageCarousel_item$data = {
  readonly carouselPhotos: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"ProductCarouselItem_photos">;
  } | null> | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"ProductCarouselItem_item">;
  readonly " $fragmentType": "ProductImageCarousel_item";
};
export type ProductImageCarousel_item$key = {
  readonly " $data"?: ProductImageCarousel_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductImageCarousel_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "fetchVideo"
    },
    {
      "defaultValue": 2,
      "kind": "LocalArgument",
      "name": "photosLimit"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductImageCarousel_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": "carouselPhotos",
      "args": [
        {
          "kind": "Variable",
          "name": "limit",
          "variableName": "photosLimit"
        }
      ],
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductCarouselItem_photos"
        }
      ],
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "fetchVideo",
          "variableName": "fetchVideo"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ProductCarouselItem_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "fcd5ddb954c88a519a81cabb68198983";

export default node;
